import React from 'react';
export function Footer() {
  return <footer className="bg-spice-900 text-spice-300 py-6 md:py-12 px-4 text-center text-sm" data-id="element-105">
      <div className="max-w-4xl mx-auto" data-id="element-106">
        <p className="mb-2" data-id="element-107">
          © La Biblia de los Condimentos Caseros — Todos los Derechos
          Reservados
        </p>
        <p className="text-spice-400" data-id="element-108">
          Producto digital con acceso inmediato tras el pago.
        </p>
      </div>
    </footer>;
}